import CountryRegionData from 'country-region-data'

import * as ApiBase from '../../APIBase'
import {
  updateAddress,
  updateAllCountries,
  updateStates,
  setInitialSelectedAddressID,
  switchToListMode,
  hideDeleteAddressModal,
  showDeleteAddressError,
  showAddAddressError,
} from './index'

export const fetchAddress = () => async (dispatch, getState) => {
  const merchantCanonicalName = getState().merchant.canonical_name ? getState().merchant.canonical_name : ''
  const url = `/${merchantCanonicalName}/customer/contact_infos`
  const accessToken = getState().user.accessToken ? getState().user.accessToken : ''
  const response = await ApiBase.get(url, {}, accessToken)
  dispatch(updateAddress(response.contact_infos))
  if (response.contact_infos && response.contact_infos.length > 0) {
    const addressList = response.contact_infos || []
    const defaultAddress = addressList.find((address) => address.default_contact === true)
    if (defaultAddress && Object.keys(defaultAddress).length > 0) {
      dispatch(setInitialSelectedAddressID(defaultAddress.id))
    }
  } else {
    throw response
  }
}

export const fetchAllCountries = () => async (dispatch, getState) => {
  const merchantCanonicalName = getState().merchant.canonical_name ? getState().merchant.canonical_name : ''
  const accessToken = getState().user.accessToken ? getState().user.accessToken : ''
  const url = `/${merchantCanonicalName}/customer/all_countries`
  const response = await ApiBase.get(url, {}, accessToken)
  if (response.all_countries) {
    dispatch(updateAllCountries(response.all_countries.sort((a, b) => (a.name > b.name ? 1 : -1))))
  } else {
    throw response
  }
}

export const fetchAllStates = (customerCountryCode) => async (dispatch) => {
  const countryRegsion = CountryRegionData
  const getCountryDetails = countryRegsion.find(
    (countries) => countries.countryShortCode === customerCountryCode,
  )
  const { regions } = getCountryDetails
  dispatch(updateStates(regions))
}

export const addAddress = () => async (dispatch, getState) => {
  const { isFormValid } = getState().address
  if (!isFormValid) {
    return
  }

  const merchantCanonicalName = getState().merchant.canonical_name ? getState().merchant.canonical_name : ''
  const url = `/${merchantCanonicalName}/customer/contact_infos`
  const accessToken = getState().user.accessToken ? getState().user.accessToken : ''
  const { selectedAddress, mode } = getState().address
  const { email } = getState().profile.info
  const newAddress = {
    first_name: selectedAddress.firstName,
    last_name: selectedAddress.lastName,
    email,
    phone: selectedAddress.phone,
    address_hash: {
      street_address: selectedAddress.street,
      landmark: selectedAddress.landmark,
      city: selectedAddress.city,
      state: selectedAddress.state,
      country: selectedAddress.country,
      postcode: selectedAddress.postCode,
      district: selectedAddress.district,
      poboxnumber: selectedAddress.postBox,
    },
  }
  let response = null
  if (mode === 'new') {
    response = await ApiBase.post(url, { ...newAddress }, accessToken)
  } else {
    response = await ApiBase.put(`${url}/${selectedAddress.id}`, { ...newAddress }, accessToken)
  }
  if (response.success) {
    dispatch(updateAddress(response.contact_infos))
    const addressList = response.contact_infos || []
    const defaultAddress = addressList.find((address) => address.default_contact === true)
    if (defaultAddress && Object.keys(defaultAddress).length > 0) {
      dispatch(setInitialSelectedAddressID(defaultAddress.id))
    }
    dispatch(switchToListMode())
  } else {
    dispatch(showAddAddressError(response.error))
  }
}

export const setDefaultAddress = () => async (dispatch, getState) => {
  const merchantCanonicalName = getState().merchant.canonical_name ? getState().merchant.canonical_name : ''
  const url = `/${merchantCanonicalName}/customer/contact_infos`
  const { id } = getState().address.selectedAddress
  const accessToken = getState().user.accessToken ? getState().user.accessToken : ''
  const response = await ApiBase.put(`${url}/${id}/default`, null, accessToken)
  if (response.contact_infos && response.contact_infos.length > 0) {
    dispatch(updateAddress(response.contact_infos))
    dispatch(setInitialSelectedAddressID(response.default_contact))
  } else {
    dispatch(showAddAddressError(response.error))
  }
}

export const deleteAddress = () => async (dispatch, getState) => {
  const merchantCanonicalName = getState().merchant.canonical_name ? getState().merchant.canonical_name : ''
  const url = `/${merchantCanonicalName}/customer/contact_infos`
  const { id } = getState().address.selectedAddress
  const accessToken = getState().user.accessToken ? getState().user.accessToken : ''
  const response = await ApiBase.del(`${url}/${id}`, null, accessToken)
  if (response.success) {
    dispatch(updateAddress(response.contact_infos))
    dispatch(hideDeleteAddressModal())
  } else {
    dispatch(showDeleteAddressError(response.error))
  }
}
